import { OnInit, Output, EventEmitter, OnDestroy, Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { Subscription } from 'rxjs';

import { UiService } from '@services/ui.service';

@Component({
    template: ""
})
export class FormEditBaseComponent implements OnInit, OnDestroy {
    @Output() editFinished = new EventEmitter<void>();

    private subscription = new Subscription();

    editForm: UntypedFormGroup;
    isLoading: boolean;

    constructor(
        protected uiSrv: UiService,
        protected fb: UntypedFormBuilder
    ) { }

    ngOnInit() {
        this.initBaseSubs();
    }

    getControl(control: string): UntypedFormControl {
        return this.editForm.get(control) as UntypedFormControl;
    }

    getArray(array: string): UntypedFormArray {
        return this.editForm.get(array) as UntypedFormArray;
    }

    private initBaseSubs(): void {
        this.subscription.add(
            this.uiSrv.loadingStateChanged
            .subscribe(loadingState => {
                this.isLoading = loadingState;
            })
        );
    }

    protected addSubscription(newSub: Subscription): void {
        this.subscription.add(newSub);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
